export const alertConstants = {
    CLEAR: 'ALERT_CLEAR',
    SHOW: 'ALERT_SHOW'
};
